import React from 'react';
import './CoursesTestimonials.css';

function CoursesTestimonials() {
    return (
        <div className='coursestestimonials-outer d-flex justify-content-center align-items-center'>
            <div className="coursestestimonials-inner d-flex justify-content-center align-items-center">
                <div id="carouselExampleIndicators" className="carousel slide">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <h2 className="secondary-paragraph">
                                “The teachers here were so supportive and friendly. They truly understand the challenges students from the hills face and guide us with patience.” - Laxmi Gurung
                            </h2>
                        </div>
                        <div className="carousel-item">
                            <h2 className="secondary-paragraph">
                                “The training I received here made me job-ready from day one. I now work as a hospitality assistant in a luxury resort in Goa.” - Nima Tamang
                            </h2>
                        </div>
                        <div className="carousel-item">
                            <h2 className="secondary-paragraph">
                                “I used to be shy and unsure of my future, but this institute gave me clarity, skill, and a job that I’m proud of. Thank you for empowering girls like me from the hills.” - Maya Rai
                            </h2>
                        </div>

                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon primary" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default CoursesTestimonials
